// extracted by mini-css-extract-plugin
export default {"select__label":"Select_select__label__glhS0","dropdown":"Select_dropdown__-mZ35","placeholder":"Select_placeholder__QSUgW"};